import randomInt from '../Utils/randomInt';
import AnswerArea from './AnswerArea';

import { useEffect, useRef } from "react";


export const settings = [];

// used on first show (when random data is needed) or on refresh
export const generateBlockData = (blockData) => {
    const data = { ...blockData.data };
    const updatedBlockData = { ...blockData };

    data.points = [
         { label: "a", x: randomInt(-6, 6), y: randomInt(-6, 6) },
         { label: "b", x: randomInt(-6, 6), y: randomInt(-6, 6) },
    ]

    updatedBlockData.data = data;
    return updatedBlockData;
};

const PointGridBlock = ({ data, showAnswerBoxes }) => {

    const { points } = data.data;
 
    //const answer = `a = (${pointAx},${pointAy})`

    const answer = points.map(p => {
        return `${p.label} = (${p.x},${p.y})`
    }).join(" ");

    return (

        <div>
            What are the coordinates of point A and point B?

            <ScatterPlot points={points} />


            <AnswerArea showAnswer={data.showAnswer} answer={answer} showAnswerBoxes={showAnswerBoxes} />
        </div>

    );

};

const ScatterPlot = (props) => {
  const canvasRef = useRef(null);

  useEffect(() => {
      const canvas = canvasRef.current;
      const ctx = canvas.getContext("2d");

      // Define chart boundaries
      const margin = 10;
      const width = canvas.width - margin * 2;
      const height = canvas.height - margin * 2;

      // Define axis limits
      const xMin = -6, xMax = 6;
      const yMin = -6, yMax = 6;

      // Function to map data values to canvas coordinates
      const mapX = (value) => margin + ((value - xMin) / (xMax - xMin)) * width;
      const mapY = (value) => margin + height - ((value - yMin) / (yMax - yMin)) * height;

      // Clear canvas
      ctx.clearRect(0, 0, canvas.width, canvas.height);

      // Draw grid lines
      ctx.lineWidth = 1;
      ctx.strokeStyle = "lightgray";
      ctx.font = "12px Arial";
      ctx.fillStyle = "black";
      ctx.textAlign = "center";
      ctx.textBaseline = "middle";

      // Function to draw text with a white background (except for the "0" label)
      const drawTextWithBackground = (text, x, y, applyBackground = true) => {
          const padding = 4;
          const textMetrics = ctx.measureText(text);
          const textWidth = textMetrics.width;
          const textHeight = 12; // Approximate font height

          if (applyBackground) {
              // Draw white background rectangle
              ctx.fillStyle = "white";
              ctx.fillRect(x - textWidth / 2 - padding, y - textHeight / 2 - padding, textWidth + padding * 2, textHeight + padding * 2);
          }

          // Draw the text on top
          ctx.fillStyle = "black";
          ctx.fillText(text, x, y);
      };

      // Draw grid lines and axis labels (excluding Y-axis -1 for now)
      for (let i = xMin; i <= xMax; i++) {
          if (i !== 0) {
              let x = mapX(i);
              ctx.beginPath();
              ctx.moveTo(x, margin);
              ctx.lineTo(x, margin + height);
              ctx.stroke();
              drawTextWithBackground(i, x, margin + height / 2 + 15);
          }
      }

      for (let i = yMin; i <= yMax; i++) {
          if (i !== 0 && i !== -1) {  // Skip -1 for now, so we draw it later
              let y = mapY(i);
              ctx.beginPath();
              ctx.moveTo(margin, y);
              ctx.lineTo(margin + width, y);
              ctx.stroke();
              drawTextWithBackground(i, margin + width / 2 - 15, y);
          }
      }

      // Add single "0" label slightly offset from the origin (no background)
      const zeroX = mapX(0) - 10;  // Shift left slightly
      const zeroY = mapY(0) + 15;  // Shift down slightly
      drawTextWithBackground("0", zeroX, zeroY, false); // No white background

      // Draw axes
      ctx.lineWidth = 1;
      ctx.strokeStyle = "black";

      // X-axis
      ctx.beginPath();
      ctx.moveTo(margin, margin + height / 2);
      ctx.lineTo(margin + width, margin + height / 2);
      ctx.stroke();

      // Y-axis
      ctx.beginPath();
      ctx.moveTo(margin + width / 2, margin);
      ctx.lineTo(margin + width / 2, margin + height);
      ctx.stroke();

      // **Step 4: Draw the -1 on the Y-axis last to make it the top layer**
      const yAxisMinusOneY = mapY(-1);
      drawTextWithBackground("-1", margin + width / 2 - 15, yAxisMinusOneY);

      // Draw a single data point
      const drawPoint = (x, y, color = "red", label = "") => {
        const pointX = mapX(x);
        const pointY = mapY(y);
    
        // Draw the point
        ctx.fillStyle = color;
        ctx.beginPath();
        ctx.arc(pointX, pointY, 4, 0, Math.PI * 2);
        ctx.fill();
    
        // Draw the label if provided
        if (label) {
            drawTextWithBackground(label, pointX + 6, pointY - 6, false);
        }
    };

    //   drawPoint(4, 3, "black", "a");
    //   drawPoint(-1, -6, "black", "b");
    props.points.forEach(p => {
        drawPoint(p.x, p.y, "black", p.label);
    });

  }, [props.points]);

  return <canvas ref={canvasRef} width={320} height={320} style={{ display: "block", margin: "0 auto" }} />;
};


export default PointGridBlock;